import React from "react";
import PropTypes from "prop-types";
import passengerConditionChoices from "./passengerConditionChoices";
import { SelectInput } from "react-admin";

const PassengerConditionInput = ({ helperText, label, source, ...props }) => (
    <SelectInput
        label={label}
        helperText={helperText}
        source={source}
        choices={passengerConditionChoices}
        {...props}
    />
);

PassengerConditionInput.propTypes = {
    label: PropTypes.string,
    helperText: PropTypes.string,
    source: PropTypes.string.isRequired,
};

PassengerConditionInput.defaultProps = {
    source: "condition",
};

export default PassengerConditionInput;
